// Shared client-side filter helpers driven by the sidebar's Status + Location
// + Requisition dropdowns. Keeping the logic here means every candidate-listing
// page filters identically.

export function applyCandidateFilters(candidates, statusFilter, locationFilter, requisitionFilter) {
  return (candidates || []).filter((c) => {
    if (statusFilter && statusFilter !== "All" && c.status !== statusFilter) return false;
    if (locationFilter && locationFilter !== "All" && c.location !== locationFilter) return false;
    if (requisitionFilter && requisitionFilter !== "All") {
      if (requisitionFilter === "__unassigned__") {
        if (c.fusionRequisitionNumber) return false;
      } else if (String(c.fusionRequisitionNumber || "") !== String(requisitionFilter)) {
        return false;
      }
    }
    return true;
  });
}

export function filtersActive(statusFilter, locationFilter, requisitionFilter) {
  return (
    (statusFilter && statusFilter !== "All")
    || (locationFilter && locationFilter !== "All")
    || (requisitionFilter && requisitionFilter !== "All")
  );
}

export function filterSummary(statusFilter, locationFilter, requisitionFilter) {
  const parts = [];
  if (statusFilter && statusFilter !== "All") parts.push(`Status: ${statusFilter}`);
  if (locationFilter && locationFilter !== "All") parts.push(`Location: ${locationFilter}`);
  if (requisitionFilter && requisitionFilter !== "All") {
    parts.push(`Requisition: ${requisitionFilter === "__unassigned__" ? "Unassigned" : requisitionFilter}`);
  }
  return parts.join(" · ");
}
